<div class="root" [class.-mobile]="isMobile">
  <ds-dialog [closeable]="false">
    <ng-container dsDialogHeader>
      <header>
        <h2 class="title">{{ title }}</h2>
      </header>
      <button class="close" (click)="onClose()">
        <ds-icon [svgContent]="icons.closeCross"></ds-icon>
      </button>
    </ng-container>

    <ng-container dsDialogBody>
      <form class="form" [formGroup]="form" skyUiNativeScroll>
        <ng-container *ngIf="!isMultiSelect; else multiSelect">
          <div class="categories">
            <ds-tabs
              (tabChange)="setCategories($event.index)"
              type="separated"
              size="s"
              *ngIf="!isMobile; else selectCategory"
            >
              <ds-tab *ngFor="let category of categories; let index = index" [active]="index === activeCategory">
                <ng-template #label>{{ category }}</ng-template>
              </ds-tab>
            </ds-tabs>
          </div>
        </ng-container>
        <ng-template #multiSelect>
          <div class="categories multi-select" [class.-one-column]="isMobile">
            <div *ngFor="let category of categories; let index = index">
              <ds-checkbox (checkedChange)="setCategories(index, $event)">
                {{ category }}
              </ds-checkbox>
            </div>
          </div>
        </ng-template>
        <div
          class="dropzone"
          maDropFilesZone
          maDropFilesZoneActionSelector=".icon-attach"
          [class.-focus]="messageFocus"
          (filesDropped)="onFilesDropped($event)"
        >
          <textarea
            formControlName="message"
            class="message"
            skyUiNativeScroll
            rows="3"
            (focus)="setMessageFocus()"
            (blur)="setMessageBlur()"
            [placeholder]="
              (denyAttach
                ? 'attachmentsDialog.optionalMessage'
                : commentIsRequired
                ? 'attachmentsDialog.requiredMessage'
                : 'attachmentsDialog.optionalMessageAndAttach'
              ) | transloco
            "
          ></textarea>
          <div class="preview" *ngIf="!denyAttach">
            <div class="thumbnails">
              <div class="thumbnail-wrapper" *ngFor="let url of previewUrls; let index = index">
                <img class="thumbnail" [src]="url | skySafeUrl" [alt]="files[index].name" (click)="openImage(index)" />
                <ds-icon class="icon-close" [svgContent]="icons.closeCircle" (click)="removeFile(index)"></ds-icon>
                <ds-icon *ngIf="progress[url] >= 0" class="icon-progress" [svgContent]="icons.progress"></ds-icon>
              </div>
            </div>
            <div class="attach">
              <ds-icon class="icon-attach" [svgContent]="icons.attach"></ds-icon>
            </div>
          </div>
        </div>
        <p *ngIf="isError$ | async" class="error">{{ 'attachmentsDialog.error.send' | transloco }}</p>
      </form>
    </ng-container>
    <ng-container dsDialogFooter>
      <ds-button [disabled]="!form.valid || (isLoading$ | async)" (click)="submit()" class="submit" type="primary-blue">
        {{ 'attachmentsDialog.actions.send' | transloco }}
      </ds-button>
    </ng-container>
  </ds-dialog>
</div>
<ng-template #selectCategory>
  <ds-select
    size="s"
    (valueChange)="setCategories($event)"
    [placeholder]="'attachmentsDialog.placeholderSelect' | transloco"
  >
    <ds-select-option *ngFor="let category of categories; let index = index" [value]="index">
      {{ category }}
    </ds-select-option>
  </ds-select>
</ng-template>

<div
  class="image-preview-popup"
  [class.-is-mobile]="isMobile"
  *ngIf="!(isLoading$ | async) && activeIndex !== null && files[activeIndex]"
>
  <div class="image-preview-row">
    <button maRound (click)="closeImage()">
      <ds-icon [svgContent]="icons.back"></ds-icon>
    </button>
  </div>
  <div class="image-preview-row">
    <img class="image-preview" [src]="previewUrls[activeIndex] | skySafeUrl" [alt]="files[activeIndex].name" />
  </div>
</div>
